import angular from 'angular';

NotesDirective.$inject = ['$uibModal', 'PermissionsService'];
function NotesDirective($uibModal, PermissionsService) {
  NotesController.$inject = ['$scope', '$timeout'];

  function NotesController($scope, $timeout) {
    const ctrl = {
      displayNotes: '',

      placeholder: '',

      updateText: 'Edit Notes',

      showLink: false,

      maxCharLimit: -1,

      displayMaxCharLimit: 150,

      modalNotes: '',
      cancelText: '',

      init: function () {
        console.log('Permissions: ' + $scope.permissions);
        this.maxCharLimit = +$scope.maxCharLimit || -1;
        this.displayMaxCharLimit = +$scope.displayMaxCharLimit || 150;
        this.placeholder = $scope.placeholder || '';
        this.showPlaceHolder();
        this.validCheck();
        this.updateActionText();

        $scope.$on('$destroy', $scope.$watch('model', this.onModelUpdate));
      },

      validCheck: function () {
        if ($scope.model) {
          if ($scope.model.split('').length >= +ctrl.displayMaxCharLimit) {
            ctrl.displayNotes = $scope.model.substring(0, ctrl.displayMaxCharLimit) + '...';
            ctrl.showLink = true;
          } else {
            ctrl.displayNotes = $scope.model;
            ctrl.showLink = false;
          }
        } else {
          ctrl.displayNotes = '';
          ctrl.showLink = false;
        }
      },

      showPlaceHolder: function () {
        return !ctrl.displayNotes;
      },

      showEdit: function () {
        const permissionValid = !$scope.permissions || PermissionsService.check($scope.permissions);
        return $scope.update !== undefined && permissionValid;
      },

      updateActionText: function () {
        if (!this.displayNotes) {
          this.updateText = 'Add Notes';
        } else {
          this.updateText = 'Edit Notes';
        }
      },

      update: function () {
        if ($scope.update !== undefined) {
          $scope.update();
        }
      },

      showNote: function (isEdit) {
        const showNoteModal = $uibModal.open({
          templateUrl: 'common/directives/notes/showNotesModal.tpl.html',
          size: 'lg',
          scope: $scope,
          controller: [
            '$scope',
            '$uibModalInstance',
            'note',
            'editable',
            'allowEdit',
            'maxCharLimit',
            function ($scope, $uibModalInstance, note, editable, allowEdit, maxCharLimit) {
              ctrl.modalNotes = note.model || '';

              $scope.isEditable = editable;

              $scope.allowEdit = allowEdit;

              $scope.charsRemaining = maxCharLimit || -1;

              $scope.charsRemainingMsg = '';

              ctrl.cancelText = 'Cancel';

              $scope.placeholderText = ctrl.placeholder || '';

              $scope.done = function () {
                $uibModalInstance.close(ctrl.modalNotes || '');
              };

              $scope.showEdit = function () {
                return allowEdit && !$scope.isEditable;
              };

              $scope.edit = function () {
                $scope.isEditable = true;
              };

              $scope.closeModal = function () {
                $uibModalInstance.dismiss('cancel');
              };

              $scope.validCheck = function () {
                const noteChars = ctrl.modalNotes.split('');
                if (noteChars.length > +maxCharLimit) {
                  $scope.charsRemainingMsg = '';
                } else {
                  if ($scope.charsRemaining >= 0) {
                    $scope.charsRemaining = maxCharLimit - noteChars.length;
                    $scope.charsRemainingMsg = 'You can type ' + $scope.charsRemaining + ' more characters.';
                  }
                }
              };

              $scope.init = function () {
                $scope.validCheck();
                if (!allowEdit) {
                  ctrl.cancelText = 'Close';
                }
              };

              $scope.init();
            },
          ],
          resolve: {
            note: function () {
              return { model: $scope.model };
            },
            editable: function () {
              return isEdit;
            },
            allowEdit: function () {
              return ctrl.showEdit();
            },
            maxCharLimit: function () {
              return $scope.maxCharLimit;
            },
          },
        });

        showNoteModal.result.then(
          function (note) {
            $scope.model = note;
            ctrl.validCheck();
            ctrl.updateActionText();
            $timeout(function () {
              ctrl.update();
            }, 200);
          },
          function () {
            // Do nothing
          }
        );
      },

      onModelUpdate: (newValue: string, oldValue: string) => {
        ctrl.validCheck();
      },
    };

    $scope.notes = ctrl;
    $scope.notes.init();
  }

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/notes/notes.tpl.html',
    scope: {
      maxCharLimit: '@',
      displayMaxCharLimit: '@',
      model: '=',
      update: '=update',
      placeholder: '@',
      permissions: '@',
    },

    link: function ($scope, $element, $attrs) {
      // Modified after controller runs
    },

    controller: NotesController,
  };
}

export const NotesDirectiveModule = angular
  .module('acme.common.directive.notes', ['ui.bootstrap', 'acme.common.service.permissions'])
  .directive('notes', NotesDirective).name;
